import { Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { Button, Label, WsColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import { AppLayoutTheme } from '../../../features/candidates/utils/CandidateHelper';
import { failed } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import useGDPRSettings from '../hooks/useGDPRSettings';

import { GdprSettingsParam } from './DataProtectionLayout';

const DataProtectionPendingDeleteRequest = () => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const params = useParams<GdprSettingsParam>();
  const [settings] = useGDPRSettings(params.companyId ?? '');
  const onView = async () => {
    setNotification(failed('No Data is available!'));
  };
  return (
    <>
      <AppLayoutTheme mx={4} my={2} p={3}>
        <Label sx={{ fontSize: 28, fontWeight: 'bold', color: WsColors.White }}>
          {settings?.companyName}
        </Label>
      </AppLayoutTheme>
      <Grid justifyContent="center" xs={12} display="flex">
        <Label sx={{ fontSize: 24, fontWeight: 'bold' }}>
          Data Protection And Privacy Settings Page
        </Label>
      </Grid>
      <Grid container xs={12} height="100%" mt={3} sx={{ backgroundColor: WsColors.White }} p={2}>
        <Grid item xs={12} justifyContent="center" display="flex" mt={5}>
          <Button variant="contained" size="large" onClick={() => onView()} sx={{ width: '40%' }}>
            View
          </Button>
        </Grid>
        <Grid item mt={4} xs={12} justifyContent="center" display="flex">
          <WsTypography variant={WsTypoVariants.TITLE} bold>
            Your data is successfully removed from the database and cannot be added without your
            permission. Recruitment Team
          </WsTypography>
        </Grid>
      </Grid>
    </>
  );
};

export default DataProtectionPendingDeleteRequest;
